import { FC } from 'react';

import styles from './business-hub-industries-stats.module.scss';

interface Stats {
    icon?: string;
    stats?: string;
    description?: string;
    background?: string;
    textColor?: string;
}

export interface Props {
    stats: Stats[];
    disclaimer?: string;
}

const BusinessHubIndustriesStats: FC<Props> = (props) => {
    const { stats, disclaimer } = props;

    return (
        <div className={styles.container}>
            <div className={styles.tiles}>
                {stats.map((tile, index) => {
                    return (
                        <div key={index} className={styles.tile} style={{ '--tile-bg-color': tile.background, '--tile-color': tile.textColor } as any}>
                            <div className={styles.icon}>
                                <img src={tile.icon} title={tile.stats} />
                            </div>
                            <div className={styles.stats} dangerouslySetInnerHTML={{ __html: tile.stats || '' }} />
                            <div className={styles.description} dangerouslySetInnerHTML={{ __html: tile.description || '' }} />
                        </div>
                    );
                })}
            </div>
            {disclaimer ? <div className={styles.disclaimer} dangerouslySetInnerHTML={{ __html: disclaimer }} /> : null}
        </div>
    );
};

export default BusinessHubIndustriesStats;
